import { authHeader, handleResponse } from '../helpers';
export const ContractorTopSellRptService = {
    GetDealerInvoicing,
    // GetDealers // New service method
};

function GetDealerInvoicing(data) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(data)
    };
   
    return fetch(`${process.env.REACT_APP_API_URL}VerificationLog/GetVerifiyContractReport`, requestOptions)
        .then(handleResponse);
}

// function GetDealers() {
//     const requestOptions = {
//         method: 'GET',
//         headers: authHeader()
//     };
//     return fetch(`${process.env.REACT_APP_API_URL}UserDMaster/DealerName`, requestOptions) // Use the correct base URL
//         .then(handleResponse);
// }